import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "originalQuery"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import { useFeaturesContext } from '../../features-context';
import { useQueryParams } from '../../query-params-context';
export var useGenerateAdvancedSearchUrl = function useGenerateAdvancedSearchUrl(genUrl) {
  var _useFeaturesContext = useFeaturesContext(),
    isGriffinNavEnabled = _useFeaturesContext.isGriffinNavEnabled;
  var _useQueryParams = useQueryParams(),
    queryParams = _useQueryParams.queryParams;
  return useCallback(function (query, baseUrl, usage) {
    var advancedSearchUrl = (genUrl === null || genUrl === void 0 ? void 0 : genUrl(query, baseUrl, usage)) || '';
    if (isGriffinNavEnabled) {
      var urlParts = advancedSearchUrl.split('?');
      // Omit text and originalQuery from the query params
      // originalQuery is used to support AutoCorrection in FPS and we don't want it
      // to persist between search queries
      var _ref = queryParams || {},
        text = _ref.text,
        originalQuery = _ref.originalQuery,
        rest = _objectWithoutProperties(_ref, _excluded);
      return "".concat(urlParts[0], "?").concat(new URLSearchParams(_objectSpread(_objectSpread({}, rest), query !== '' && {
        text: query
      })).toString());
    }
    return advancedSearchUrl;
  }, [genUrl, isGriffinNavEnabled, queryParams]);
};